export const PROVISIONED_UI_FLAGS = Object.freeze({
    IM_MAAFCO_UI: 'IM_MAAFCO_UI',
    IM_MOLD_REPAIR_UI: 'IM_MOLD_REPAIR_UI',
    UI_CPQ_QUOTES_INTEGRATION_V2: 'UI_CPQ_QUOTES_INTEGRATION_V2',
    NON_IM_DFM_UI: 'NON_IM_DFM_UI',
    ENABLE_DELETED_QUOTE: 'ENABLE_DELETED_QUOTE',
    ENABLE_PART_REUSABILITY: 'ENABLE_PART_REUSABILITY_UI',
})
